const awsmobile = {
    "aws_user_pools_id": process.env.REACT_APP_COGNITO_USERPOOLID,
    "aws_cognito_region": process.env.REACT_APP_COGNITO_REGION,
    "aws_user_pools_web_client_id": process.env.REACT_APP_COGNITO_USERPOOLWEBCLIENTID
    
  }
export default awsmobile;